import React from "react";
import useSearchQueryParams from "./useSearchQueryParams";
import fp from "lodash/fp";

const withSearchQueryParams = (options) => {
    return (WrappedComponent) => {
        const WithComponent = (props) => {
            const searchQueryParams = useSearchQueryParams({
                addedSchema: fp.get("addedSchema", options),
                removeExtraParams: fp.get("removeExtraParams", options),
            });
            const newProps = {
                ...props,
                searchQueryParams,
            };
            return React.createElement(WrappedComponent, newProps);
        };

        return WithComponent;
    };
};

export default withSearchQueryParams;
